export default "__VITE_ASSET__BcXOGiAC__"